import { createContext } from "react";

const UserAttributesContext = createContext();

export default UserAttributesContext;
